import Link from "next/link"
import { useLocalizedField } from '@/hooks/useLocalizedField'
import { useLocale } from 'next-intl'

interface StateCardProps {
  item: any
}

export default function StateCard({ item }: StateCardProps) {
  const { getLocalizedField } = useLocalizedField()
  const locale = useLocale()
  
  return (
    <Link
      href={`/states/${item.slug}`}
      className="group relative h-64 w-full sm:h-80 sm:w-48 lg:h-96 lg:w-60 overflow-hidden rounded-3xl cursor-pointer"
    >
      <img
        src={item.images[3]}
        alt={getLocalizedField(item, 'name')}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />

      <div className="absolute bottom-4 left-4 right-4 sm:bottom-8 sm:left-6 sm:right-auto lg:bottom-24 p-4 flex items-end">
        <h2 className={`text-white font-bold text-base sm:text-lg origin-bottom-left whitespace-nowrap ${
          locale === 'ar' 
            ? 'sm:rotate-90 sm:translate-y-full' 
            : 'sm:-rotate-90 sm:translate-y-full'
        }`}>
          {getLocalizedField(item, 'name')}
        </h2>
      </div>
    </Link>
  )
}
